<template>
  <div class="stepper">
    <div class="stepper__nav">
      <stepper-nav
        :stepItems="stepItems"
        :active-step="activeStep"
      ></stepper-nav>
    </div>
    <div class="stepper__content">
      <div class="steps">
        <div class="step__item" v-if="activeStep===1">
          <slot name="tab1"></slot>
        </div>
        <div class="step__item" v-if="activeStep===2">
          <slot name="tab2"></slot>
        </div>
        <div class="step__item" v-if="activeStep===3">
          <slot name="tab3"></slot>
        </div>
        <div class="step__item" v-if="activeStep===4">
          <slot name="tab4"></slot>
        </div>
      </div>
    </div>
    <div class="stepper__footer">
      <button class="btn btn-secondary"
              :disabled="activeStep <= 1"
              @click="activeStepChange('back')">Zurück
      </button>
      <button class="btn btn-primary"
              v-if="activeStep < stepItems.length"
              @click="activeStepChange('next')">Weiter
      </button>
      <button class="btn btn-primary"
              v-if="activeStep === stepItems.length"
              @click="submitForm">Jetzt Soli-Ersparnis berechnen
      </button>
    </div>
  </div>
</template>

<script>
import StepperNav from "./StepperNav";


export default {
  name: "stepper",
  components: {
    StepperNav,
  },
  props: {
    stepItems: {
      type: Array,
      required: true,
      description: "An array of stepper items."
    },
    activeStep: {
      type: Number,
      required: true,
      description: "Index of the active item."
    },
  },
  emits: ['submit-form', 'change-tab'],
  data() {
    return {
      activeTab: this.activeStep,
    }
  },
  methods: {
    activeStepChange(action) {
      this.$emit('change-tab', action);
    },
    submitForm() {
      this.$emit('submit-form');
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.stepper {
  flex-grow: 2;
  display: flex;
  flex-direction: column;

  &__content {
    flex-grow: 2;
    padding-top: 1rem;

    // 992px window width and more
    @include lg {
      padding-top: 3rem;
    }

    @include rwd(992) {
      padding-top: 4rem;
    }
  }
  &__footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 1rem 0 0 0;

    button {
      margin-bottom: 1rem;
    }

    // 992px window width and more
    @include lg {
      width: 100%;
      padding: 1rem 0;
    }

    @include rwd(992) {
      padding: 2rem;
    }

    & .btn:disabled {
      opacity: 0;
    }
  }
}
</style>
